
import React from 'react';
import HeaderOne from "../components/header/HeaderOne";
import { Link } from 'react-router-dom';
import FooterOne from "../components/footer/FooterOne";
import Breadcrumb from "./Breadcrumb";

function ContactUs() {
    const breadcrumbs = [
        { label: 'Accueil', link: '/' },
        { label: 'Contact' }
    ];
    return (
        <div className=''>

            <HeaderOne />


            {/* Hero section avec titre */}
            <div className="rts-section-gap" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', paddingTop: '80px', paddingBottom: '80px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="rts-title-area">
                                <p className="pre-title" style={{ fontSize: '18px', fontWeight: '600', color: '#5D666F', marginBottom: '15px' }}>Contactez-nous</p>
                                <h2 className="title" style={{ fontSize: '48px', fontWeight: '700', color: '#1C2539', marginBottom: '20px' }}>
                                    Nous sommes là pour vous aider
                                </h2>
                                <p style={{ fontSize: '18px', color: '#5D666F', maxWidth: '700px', margin: '0 auto' }}>
                                    N'hésitez pas à nous contacter pour toute question ou demande de devis. Notre équipe est à votre disposition.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* contact single area start */}
            <div className="rts-contact-area rts-section-gap" style={{ marginTop: '-40px' }}>
                <div className="container">
                    <div className="row g-5">
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner" style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div className="content">
                                    <div className="icone" style={{ marginBottom: '20px' }}>
                                        <img src="assets/images/contact/shape/01.svg" alt="" style={{ width: '50px' }} />
                                    </div>
                                    <div className="info">
                                        <span style={{ fontSize: '14px', color: '#5D666F', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Appelez-nous 24/7</span>
                                        <Link to={'tel:+242067972870'} style={{ display: 'block', marginTop: '10px', textDecoration: 'none' }}>
                                            <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', margin: '5px 0' }}>06 797 28 70</h5>
                                        </Link>
                                        <Link to={'tel:+242050400771'} style={{ display: 'block', textDecoration: 'none' }}>
                                            <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', margin: '5px 0' }}>05 040 07 71</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner" style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div className="content">
                                    <div className="icone" style={{ marginBottom: '20px' }}>
                                        <img src="assets/images/contact/shape/02.svg" alt="" style={{ width: '50px' }} />
                                    </div>
                                    <div className="info">
                                        <span style={{ fontSize: '14px', color: '#5D666F', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Envoyez-nous un email</span>
                                        <Link to={'mailto:contact@global-servicescg.com'} style={{ display: 'block', marginTop: '10px', textDecoration: 'none' }}>
                                            <h5 style={{ fontSize: '18px', fontWeight: '700', color: '#1C2539', wordBreak: 'break-word' }}>contact@global-servicescg.com</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner" style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div className="content">
                                    <div className="icone" style={{ marginBottom: '20px' }}>
                                        <img src="assets/images/contact/shape/03.svg" alt="" style={{ width: '50px' }} />
                                    </div>
                                    <div className="info">
                                        <span style={{ fontSize: '14px', color: '#5D666F', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Notre adresse</span>
                                        <Link to={'#'} style={{ display: 'block', marginTop: '10px', textDecoration: 'none' }}>
                                            <h5 style={{ fontSize: '16px', fontWeight: '600', color: '#1C2539', lineHeight: '1.6' }}>Entrée Port de Pointe-Noire, en diagonale de la Banque Postale du Port, Pointe-Noire – République du Congo</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                    </div>
                </div>
            </div>
            {/* conact single area end */}

            {/* bizup map area start */}
            <div className="rts-contact-map-area">
                <div className="contaciner-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact-map-area-fluid" style={{ position: 'relative', height: '500px', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                                <iframe
                                    className="contact-map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15856.123456789!2d11.856389!3d-4.776389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNMKwNDYnMzUuMCJTIDExwrA1MTIzLjAiRQ!5e0!3m2!1sfr!2scg!4v1234567890123!5m2!1sfr!2scg"
                                    style={{ border: 0, width: '100%', height: '100%' }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                                <img
                                    className="location"
                                    src="assets/images/contact/shape/location.svg"
                                    alt="Business_map"
                                    style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* bizup map area end */}
            {/* conact us form fluid start */}
            <div className="rts-contact-form-area rts-section-gap" style={{ background: '#f8f9fa' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 col-12 mx-auto">
                            <div className="rts-contact-fluid" style={{ 
                                background: '#fff', 
                                borderRadius: '20px', 
                                padding: '60px 50px',
                                boxShadow: '0 15px 50px rgba(0,0,0,0.08)'
                            }}>
                                <div className="rts-title-area contact-fluid text-center mb--50">
                                    <p className="pre-title" style={{ fontSize: '18px', fontWeight: '600', color: '#5D666F', marginBottom: '15px' }}>Formulaire de contact</p>
                                    <h2 className="title" style={{ fontSize: '36px', fontWeight: '700', color: '#1C2539' }}>Envoyez-nous un message</h2>
                                    <p style={{ fontSize: '16px', color: '#5D666F', marginTop: '15px', maxWidth: '600px', margin: '15px auto 0' }}>
                                        Remplissez le formulaire ci-dessous et notre équipe vous répondra dans les plus brefs délais.
                                    </p>
                                </div>
                                <div className="form-wrapper">
                                    <div id="form-messages" />
                                    <form id="contact-form">
                                        <div className="name-email">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Votre nom complet *"
                                                required=""
                                                style={{ 
                                                    background: '#F7F7F7',
                                                    border: '2px solid transparent',
                                                    borderRadius: '12px',
                                                    padding: '18px 25px',
                                                    fontSize: '16px',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.border = '2px solid var(--color-primary)';
                                                    e.target.style.background = '#fff';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.border = '2px solid transparent';
                                                    e.target.style.background = '#F7F7F7';
                                                }}
                                            />
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Votre adresse email *"
                                                required=""
                                                style={{ 
                                                    background: '#F7F7F7',
                                                    border: '2px solid transparent',
                                                    borderRadius: '12px',
                                                    padding: '18px 25px',
                                                    fontSize: '16px',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.border = '2px solid var(--color-primary)';
                                                    e.target.style.background = '#fff';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.border = '2px solid transparent';
                                                    e.target.style.background = '#F7F7F7';
                                                }}
                                            />
                                        </div>
                                        <input 
                                            type="text" 
                                            name="subject" 
                                            placeholder="Sujet de votre message" 
                                            style={{ 
                                                background: '#F7F7F7',
                                                border: '2px solid transparent',
                                                borderRadius: '12px',
                                                padding: '18px 25px',
                                                fontSize: '16px',
                                                marginBottom: '25px',
                                                width: '100%',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.border = '2px solid var(--color-primary)';
                                                e.target.style.background = '#fff';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.border = '2px solid transparent';
                                                e.target.style.background = '#F7F7F7';
                                            }}
                                        />
                                        <textarea
                                            placeholder="Votre message *"
                                            name="message"
                                            defaultValue={""}
                                            required=""
                                            style={{ 
                                                background: '#F7F7F7',
                                                border: '2px solid transparent',
                                                borderRadius: '12px',
                                                padding: '18px 25px',
                                                fontSize: '16px',
                                                minHeight: '180px',
                                                width: '100%',
                                                resize: 'vertical',
                                                transition: 'all 0.3s ease',
                                                fontFamily: 'inherit'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.border = '2px solid var(--color-primary)';
                                                e.target.style.background = '#fff';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.border = '2px solid transparent';
                                                e.target.style.background = '#F7F7F7';
                                            }}
                                        />
                                        <button 
                                            type="submit" 
                                            className="rts-btn btn-primary"
                                            style={{
                                                marginTop: '30px',
                                                padding: '18px 40px',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                borderRadius: '12px',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            Envoyer le message
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* conact us form fluid end */}

            <FooterOne />

        </div>
    )
}

export default ContactUs